module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-absolute u-fit u-pos-tl"
  }, [_c('transition-group', {
    attrs: {
      "name": "c-bg__group",
      "tag": "div"
    }
  }, _vm._l((_vm.items), function(img) {
    return (img.enable) ? _c('div', {
      key: img.src,
      staticClass: "u-absolute u-fit-w u-overflow-h"
    }, [_c('div', {
      staticClass: "c-bg__img-container u-relative u-overflow-h"
    }, [(img.isVideo) ? _c('video', {
      staticClass: "c-bg__img u-height-a",
      style: ({
        'opacity': img.opacity,
        transform: _vm.transformScrollImg
      }),
      attrs: {
        "autoplay": "",
        "muted": "",
        "playsinline": "",
        "loop": ""
      }
    }, [_c('source', {
      attrs: {
        "src": img.src,
        "type": "video/mp4"
      }
    })]) : _c('img', {
      staticClass: "c-bg__img u-height-a",
      style: ({
        'opacity': img.opacity,
        transform: _vm.transformScrollImg
      }),
      attrs: {
        "src": img.src,
        "alt": "Background"
      }
    })]), _vm._v(" "), _c('img', {
      staticClass: "c-bg__mask u-fit-w u-height-a",
      attrs: {
        "src": "/static/bg/mask.png"
      }
    })]) : _vm._e()
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24e8fb2c"}!./src/scripts/components/app-bg/template.html
// module id = 894
// module chunks = 0